<template>
  <div>
    <div class="px-4">
     <!-- <p class="text-center my-4">To get your rebate, you’ll need to supply <strong>three (3) months’ worth of bills</strong> from a participating provider.  Bills must include Showtime as a paid service for each of the three (3) months.  Bills can be submitted in PDF, JPG or PNG formats.  Rebate may only apply once, subject to provider rules.</p> -->
    <div class="mt-5 mb-3">
        <h4 class="text-center peak-sans">CHOOSE YOUR PROVIDER</h4>
    </div>
    <div class="mt-4 mx-auto">
        <div class="mb-2">
            <button @click="updateProvider({name: 'Cox', logo: './img/frontend/logos/cox.svg'})"  class="show-btn">Cox</button>
        </div>
      <!-- <div class="mb-2">
            <button @click="updateProvider({name: 'DirecTV', logo: './img/frontend/logos/directv.svg'})" class="show-btn">DirecTV</button>
        </div>
        <div class="mb-2">
            <button @click="updateProvider({name: 'DirecTV Stream', logo: './img/frontend/logos/directv-stream.svg'})" class="show-btn">DirecTV Stream</button>
      </div> -->
      <div class="mb-2">
            <button @click="updateProvider({name: 'Mediacom', logo: './img/frontend/logos/Xtream.png'})" class="show-btn">Xtream By Mediacom</button>
      </div>
        <div class="mb-2">
            <button @click="updateProvider({name: 'Verizon Fios', logo: './img/frontend/logos/verizon.svg'})" class="show-btn">Verizon</button>
        </div>
         <select v-model="provider" class="show-btn text-center" value = "Other" @change="updateProvider({name: provider});" style="text-align-last:center;" > Other
            <option disabled selected value="">OTHER</option>
            <option v-for="(provider, index) in availableProviders" :key="index">{{provider}}</option>
        </select>
    </div>
    </div>
    <div class="my-5 text-center">
        <a href="https://shodotcom.zendesk.com/hc/en-us/articles/4604273157275-How-do-I-know-if-my-provider-participates-in-the-SHOWTIME-rebate-program" target="_blank" class="text-center din-demi text-link text-center text-red border p-2">Don’t See Your Provider? </a>
    </div>
  </div>
</template>

<script>
    export default {
        name:"ProviderSelection",
        data(){
            return{
                provider:''
            }
        },
        methods: {
            updateProvider(providerChosen){
                this.provider = providerChosen;
                this.$emit('providerChosen',this.provider);
                console.log(this.provider);
            }
        },
        computed:{
            availableProviders(){
                return this.$store.state.providers;
            }
        }
    }
</script>
